import Vue from 'vue'
import lodashSet from 'lodash.set'
import moment from 'moment-timezone'
import { uuid } from 'vue-uuid'

export default {
  setPageCategory(state, pageCategory) {
    state.pageCategory = pageCategory
  },
  setPageType(state, pageType) {
    state.pageType = pageType
  },
  setLanding(state, landing) {
    state.landing = landing
  },
  setName(state, name) {
    state.name = name
  },
  setTitle(state, title) {
    state.title = title
  },
  setPublish(state, published) {
    state.published = published
  },
  setActive(state, activeId) {
    state.activeId = activeId
  },
  setCurrentView(state, view) {
    state.currentView = view
  },
  setPanelToCopy(state, id) {
    state.panelCopied = id
  },
  setCurrentNavBar(state, navBar) {
    state.currentNavBar = navBar
  },

  insert(state, { item, parentId }) {
    if (parentId) {
      state.landing.find(l => l.id === parentId).children.push(item.id)
    }
    state.landing.push(item)
  },

  remove(state, id) {
    const toRemove = state.landing.find(l => l.id === id)

    if (toRemove.type !== 'Section') {
      const parentId = toRemove.path[toRemove.path.length - 1]
      const parent = state.landing.find(l => l.id === parentId)

      parent.children = parent.children.filter(c => c !== id)
    }

    Vue.delete(
      state.landing,
      state.landing.findIndex(l => l.id === id)
    )
  },

  reposition(state, reposition) {
    reposition.forEach(item => {
      const toReposition = state.landing.find(l => l.id === item.id)
      toReposition.options[item.key].position = item.to
    })
  },

  updateOptions(state, { id, path, value }) {
    lodashSet(
      state.landing.find(l => l.id === id),
      `options${path && `.${path}`}`,
      value
    )
  },

  updateTabItems(state, { id, path, value }) {
    lodashSet(
      state.landing.find(l => l.id === id),
      `items${path && `.${path}`}`,
      value
    )
  },

  removeTabsItem(state, { id, index }) {
    const { items, children } = state.landing.filter(l => l.id === id)[0]
    const newItems = items.filter((_, i) => i !== index)
    const newChildren = children.filter((_, i) => i !== index)
    lodashSet(
      state.landing.find(l => l.id === id),
      'items',
      newItems
    )
    lodashSet(
      state.landing.find(l => l.id === id),
      'children',
      newChildren
    )
  },

  addTabsItem(state, { id, index }) {
    const { items } = state.landing.filter(l => l.id === id)[0]
    items.splice(index, 0, {
      id: uuid.v1(),
      title: `Webinar ${index + 1}`,
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus hendrerit',
      button: 'Assistir',
      options: {
        sm: {
          dateColor: '#55BDCA',
        },
        md: {
          dateColor: '#55BDCA',
        },
        lg: {
          dateColor: '#55BDCA',
        },
      },
      date: moment().format('YYYY-MM-DD'),
      time: moment().format('HH:mm:ss'),
    })

    lodashSet(
      state.landing.find(l => l.id === id),
      'items',
      items
    )
  },

  removeTabs(state, { ids }) {
    state.landing = state.landing.filter(l => !ids.includes(l.id))
  },

  removeHeroSparkBanner(state, { ids }) {
    state.landing = state.landing.filter(l => !ids.includes(l.id))
  },

  updateTitle(state, { id, value }) {
    lodashSet(
      state.landing.find(l => l.id === id),
      `title`,
      value
    )
  },

  updatePosition(state, toMove) {
    toMove.forEach(el => {
      state.landing.find(l => l.id === el.id).options[state.currentView].position = el.position
    })
  },

  updateFormItem(state, { id, formItemId, path, value }) {
    const form = state.landing.find(l => l.id === id)
    lodashSet(
      form.options.items.find(l => l.id === formItemId),
      `options${path && `.${path}`}`,
      value
    )
  },

  updateFormItemPosition(state, { id, toMove }) {
    const form = state.landing.find(l => l.id === id)
    toMove.forEach(el => {
      form.options.items.find(l => l.id === el.id).options.position[state.currentView] = el.position
    })
  },

  addFormItem(state, { id, formItem, reposition }) {
    const form = state.landing.find(l => l.id === id)
    form.options.items.push(formItem)

    reposition.forEach(item => {
      const toReposition = form.options.items.find(i => i.id === item.id)
      toReposition.options.position[item.key] = item.to
    })
  },

  removeFormItem(state, { id, formItemId, reposition }) {
    const form = state.landing.find(l => l.id === id)

    form.options.items = form.options.items.filter(i => i.id !== formItemId)

    reposition.forEach(item => {
      const toReposition = form.options.items.find(i => i.id === item.id)
      toReposition.options.position[item.key] = item.to
    })
  },

  batchAdd(state, { parentId, elements }) {
    if (parentId) {
      state.landing.find(l => l.id === parentId).children.push(elements[0].id)
    }

    state.landing.push(...elements)
  },

  batchRemove(state, { parentId, elements }) {
    if (parentId) {
      const parent = state.landing.find(l => l.id === parentId)
      parent.children = parent.children.filter(c => !elements.includes(c))
    }

    state.landing = state.landing.filter(l => !elements.includes(l.id))
  },
}
